export const checkIfNCentral = (serialNumber: string): boolean | null => {
  if (!serialNumber) {
    return null
  }
  if (serialNumber.length !== 16) {
    return null
  }
  return serialNumber.slice(8, 10) === '16'
}
